import workunisicknote from '../assets/workunisicknote.png';
import uniunwell from '../assets/unwelluni.png';
import statementoffact from '../assets/gpreferral.png';
import studentsickness from '../assets/uniexemption.png';
import studentextenuating from '../assets/studentextenuating.png';
import returntowork from '../assets/returntowork.png';
import pneumoniarecovery from '../assets/bronchitis.jpg';
import carersleave from '../assets/carersleave.png';
import unwellwork from '../assets/unwellwork.png';
import jurydutyexemption from '../assets/juryservice.png';
import pregnancyfittofly from '../assets/fittoflypreg.png';
import gpreferral from '../assets/gpreferral.png';
import specialistreferral from '../assets/privateinvestigation.png';
import osteopathreferral from '../assets/osteopathy.png';
import physiotherapyreferral from '../assets/privatephysio.png';
import timorlestevisa from '../assets/timorlesete.png';
import loasvisa from '../assets/loas.jpg';
import podiatryreferral from '../assets/podiatry.png';
import spanishvisa from '../assets/spanish.png';
import chinesevisa from '../assets/chinese.jpg';
import caymanislandsvisa from '../assets/cayman.png';
import kuwaitvisa from '../assets/kuwait.png';
import bahrainvisa from '../assets/bahrain.png';
import stkittsnevisvisa from '../assets/stkitts.jpg';
import saudiarabia from '../assets/SaudiArabia.png';
import japanesemedicalcertificate from '../assets/japanese.jpg';
import southafricanvisa from '../assets/southafrican.jpg';
import italianvisa from '../assets/italian.png';
import barbadosvisa from '../assets/barbados.png';
import maldivesmedicalcertificate from '../assets/maldives.avif';
import uaemedicalcertificate from '../assets/uae.png';
import qatarmedicalcertificate from '../assets/qatar.png';
// import thaimedicalcertificate from '../assets/thai.jpg';
import vietnammedicalcertificate from '../assets/vietnam.png';
import taiwanmedicalcertificate from '../assets/taiwan.png';
import indonesiamedicalcertificate from '../assets/indonesia.jpg';
import southkoreamedicalcertificate from '../assets/southkorea.png';
import singaporevisa from '../assets/singapore.jpg';
import bermuda from '../assets/bermuda.jpg';
import bruneivisa from '../assets/brunei.png';
import cambodiavisa from '../assets/cambodia.png';
import myanmarvisa from '../assets/myanmar.png';
import shinglesrecovery from '../assets/shingles.jpg';
import chickenpoxrecovery from '../assets/chickenpox.jpg';
import scarletfeverrecovery from '../assets/scarletfever.jpg';
import glandularfeverrecovery from '../assets/sorethroat.jpeg';
import fittofly from '../assets/travel2.png'; // Corrected path if needed, now used
import holidaycancellation from '../assets/holidaycancellation.png'; // Corrected path if needed, now used
import travelmedication from '../assets/travelwithmeds.png';
import allergytravel from '../assets/allergyplane.png';
import tonsillitisrecovery from '../assets/sorethroat.jpeg';
import grenada from '../assets/grenada.jpg';
import thaimedicalcertificate from '../assets/thai.jpg';
import malasiamedicalcertificate from '../assets/malasia.png';
import philippinescertificate from '../assets/phillipines.png';
import bronchitisrecovery from '../assets/bronchitis.jpg';
import measlesrecovery from '../assets/measles.jpg';
import mumpsrecovery from '../assets/mumps.jpg';
import rubellarecovery from '../assets/rubella.jpg';
import whoopingcoughrecovery from '../assets/whoopingcough.jpg';
import handfootmouthrecovery from '../assets/handfootmouth.jpg';
import gastroenteritisrecovery from '../assets/gastroenteritisrecover.png';
import cellulitisrecovery from '../assets/cellulitisrecovery.png';
import earinfectionrecovery from '../assets/earinfectionrecovery.png';
import sinusitisrecovery from '../assets/sinusiits.jpg';
import utirecovery from '../assets/uti.png';
import migrainerecovery from '../assets/migrainerecovery.png';
import vertigorecovery from '../assets/vertigorecovery.png';
import backpainrecovery from '../assets/backpain.png';
import anxietystressrecovery from '../assets/anxiety.png';
import depressionrecovery from '../assets/depression.png';
import insomniarecovery from '../assets/insomnia.png';
import panicattackrecovery from '../assets/panicattack.png';
import bereavementrecovery from '../assets/bereavement.png';


// const placeholderImage = 'https://placehold.co/300x200.png?text=Service';

export const serviceCategories = [
    { name: 'All Services', path: '/services', id: 'all-services' },
    { name: 'Sickness Letters', path: '/services/sickness-letters', id: 'sickness-letters' },
    { name: 'Travel & Holiday Letters', path: '/services/travel-holiday-letters', id: 'travel-holiday-letters' },
    { name: 'Visa Medical Certificates', path: '/services/visa-medical-certificates', id: 'visa-medical-certificates' },
    { name: 'General Referrals', path: '/services/general-referrals', id: 'general-referrals' },
    { name: 'Recovery Certificates', path: '/services/recovery-certificates', id: 'recovery-certificates' },
];

export const allServices = [
    // Sickness Letters
    {
        id: 'sick-note-work-uni',
        name: 'Same-Day Sick Note for Work or University',
        price: 1, // Price in pence as an integer
        description: 'A verifiable sick note for absence from work or university, delivered same-day.',
        image: workunisicknote,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'sick-note-work-uni',
    },
    {
        id: 'self-cert-note',
        name: 'Self-Certification Sick Note',
        price: 1, // Price in pence as an integer
        description: 'A self-certification form for short-term illness, as required by many employers.',
        image: unwellwork,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'sick-note-work-uni',
    },
    {
        id: 'uni-college-note',
        name: 'University & College Sick Note',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate for university or college absence due to illness.',
        image: studentsickness,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'sick-note-work-uni',
    },
    {
        id: 'uni-extenuating-circs',
        name: 'University Extenuating Circumstances Letter',
        price: 1, // Price in pence as an integer
        description: 'A detailed letter to support your claim for extenuating circumstances.',
        image: uniunwell,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'academic-exemption',
    },
    {
        id: 'exam-exemption',
        name: 'Exam & Coursework Exemption Letter',
        price: 1, // Price in pence as an integer
        description: 'A formal letter from a doctor to support exam or coursework exemptions.',
        image: studentextenuating,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'academic-exemption',
    },
    {
        id: 'carers-leave-cert',
        name: "Carer's Leave Certificate",
        price: 1, // Price in pence as an integer
        description: 'A certificate to confirm your role as a carer for a family member or friend.',
        image: carersleave,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'carers-leave',
    },
    {
        id: 'return-to-work-cert',
        name: 'Return to Work Certificate',
        price: 1, // Price in pence as an integer
        description: 'A fit note to confirm you are medically fit to return to your duties at work.',
        image: returntowork,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
        requiresQuestionnaire: 'return-to-work'
    },
    {
        id: 'jury-duty-exemption',
        name: 'Jury Duty Exemption Letter',
        price: 1,
        description: 'A medical letter to support your request for exemption from jury duty.',
        image: jurydutyexemption,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true, // For jury summons letter
        requiresQuestionnaire: 'admin-travel-exemption',
    },
    {
        id: 'statement-of-fact',
        name: 'Statement of Fact Letter',
        price: 1,
        description: 'A factual medical letter from a UK doctor for various official purposes.',
        image: statementoffact,
        category: 'Sickness Letters',
        path: '/services/sickness-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'admin-travel-exemption',
    },

    // Travel & Holiday Letters
    {
        id: 'fit-to-fly',
        name: 'Fit to Fly Certificate',
        price: 1,
        description: 'A medical certificate to confirm you are fit to fly, as required by many airlines.',
        image: fittofly,
        category: 'Travel & Holiday Letters',
        path: '/services/travel-holiday-letters',
        requiresScr: false,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'maternity-travel'
    },
    {
        id: 'holiday-cancellation',
        name: 'Holiday Cancellation Letter',
        price: 1,
        description: 'A letter from a doctor to support your holiday cancellation claim for insurance.',
        image: holidaycancellation,
        category: 'Travel & Holiday Letters',
        path: '/services/travel-holiday-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'admin-travel-exemption',
    },
    {
        id: 'pregnancy-fit-to-fly',
        name: 'Airline Fit to Fly Letter for Pregnancy',
        price: 1,
        description: 'A certificate confirming your fitness to fly during pregnancy.',
        image: pregnancyfittofly,
        category: 'Travel & Holiday Letters',
        path: '/services/travel-holiday-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'maternity-travel',
    },
    {
        id: 'travel-medication',
        name: 'Travel with Medication Letter',
        price: 1,
        description: 'An official letter to carry with you when travelling with prescribed medication.',
        image: travelmedication,
        category: 'Travel & Holiday Letters',
        path: '/services/travel-holiday-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'admin-travel-exemption',
    },
    {
        id: 'allergy-travel',
        name: 'Allergy & Anaphylaxis Travel Certificate',
        price: 1,
        description: 'A medical certificate detailing your allergies for safe travel.',
        image: allergytravel,
        category: 'Travel & Holiday Letters',
        path: '/services/travel-holiday-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'admin-travel-exemption',
    },
    {
        id: 'chickenpox-travel',
        name: 'Chickenpox (Varicella) Travel Certificate',
        price: 1,
        description: 'A certificate to confirm you or your child is no longer infectious and fit to travel.',
        image: chickenpoxrecovery,
        category: 'Travel & Holiday Letters',
        path: '/services/travel-holiday-letters',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: true,
    },
    {
        id: 'cruise-travel',
        name: 'Cruise Ship Travel Certificate',
        price: 1, // Price in pence as an integer
        description: 'A fit to travel certificate specifically for cruise ship requirements.',
        image: fittofly,
        category: 'Travel & Holiday Letters',
        requiresQuestionnaire: true,
        path: '/services/travel-holiday-letters',
    },

    // // General Referrals
    {
        id: 'gp-referral',
        name: 'GP Referral Letter',
        price: 1,
        description: 'A comprehensive referral letter from a UK GP to a specialist of your choice.', // eslint-disable-line max-len
        image: gpreferral,
        category: 'General Referrals',
        path: '/services/general-referrals',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresPhotoEvidence: false,
    },
    {
        id: 'specialist-referral',
        name: 'Private Specialist Referral Letter',
        price: 1,
        description: 'A referral to a private specialist, helping you bypass long waiting times.', // eslint-disable-line max-len
        image: specialistreferral,
        category: 'General Referrals',
        path: '/services/general-referrals',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'physio-referral',
        name: 'Private Physiotherapy Referral Letter',
        price: 1,
        description: 'A referral letter to a private physiotherapist for assessment and treatment.', // eslint-disable-line max-len
        image: physiotherapyreferral,
        category: 'General Referrals',
        path: '/services/general-referrals',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
    },
    {
        id: 'podiatry-referral',
        name: 'Private Podiatry & Chiropody Referral',
        price: 1,
        description: 'A referral to a private podiatrist for foot and ankle care.', // eslint-disable-line max-len
        image: podiatryreferral,
        category: 'General Referrals',
        path: '/services/general-referrals',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
    },
    {
        id: 'osteopathy-referral',
        name: 'Private Osteopathy Referral Letter',
        price: 1,
        description: 'A referral to a private osteopath for musculoskeletal issues.', // eslint-disable-line max-len
        image: osteopathreferral,
        category: 'General Referrals',
        path: '/services/general-referrals',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresPhotoEvidence: false,
    },

    // // Visa Medical Certificates
    {
        id: 'spanish-visa-medical-certificate',
        name: 'Spanish Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Spanish visa requirements.',
        image: spanishvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },
    {
        id: 'chinese-visa-medical-certificate',
        name: 'Chinese Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Chinese visa requirements.',
        image: chinesevisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },
    {
        id: 'cayman-islands-visa-medical-certificate',
        name: 'Cayman Islands Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Cayman Islands visa requirements.',
        image: caymanislandsvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },
    {
        id: 'kuwait-visa-medical-certificate',
        name: 'Kuwait Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Kuwaiti visa requirements.',
        image: kuwaitvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },
    {
        id: 'bahrain-visa-medical-certificate',
        name: 'Bahrain Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Bahraini visa requirements.',
        image: bahrainvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },
    {
        id: 'st-kitts-nevis-visa-medical-certificate',
        name: 'St Kitts & Nevis Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for St Kitts & Nevis visa requirements.',
        image: stkittsnevisvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },
    {
        id: 'saudi-arabia-visa-medical-certificate',
        name: 'Saudi Arabia Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Saudi Arabian visa requirements.',
        image: saudiarabia,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'japanese-visa-medical-certificate',
        name: 'Japanese Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Japanese visa requirements.',
        image: japanesemedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'south-african-visa-medical-certificate',
        name: 'South African Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for South African visa requirements.',
        image: southafricanvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'italian-visa-medical-certificate',
        name: 'Italian Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Italian visa requirements.',
        image: italianvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'barbados-visa-medical-certificate',
        name: 'Barbados Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Barbadian visa requirements.',
        image: barbadosvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'bermuda-visa-medical-certificate',
        name: 'Bermuda Visa Medical Certificate',
        price: 1, // Price in pence as an integer
        description: 'A specific medical certificate for Bermudian visa requirements.', // eslint-disable-line max-len
        image: bermuda,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'grenada-visa-medical-certificate',
        name: 'Grenada Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Grenadian visa requirements.', // eslint-disable-line max-len
        image: grenada,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: true,
        requiresPhotoEvidence: false,
    },
    {
        id: 'maldives-visa-medical-certificate',
        name: 'Maldives Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Maldivian visa requirements.',
        image: maldivesmedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
    },

    {
        id: 'uae-visa-medical-certificate',
        name: 'UAE Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for UAE visa requirements.',
        image: uaemedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'qatar-visa-medical-certificate',
        name: 'Qatar Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Qatari visa requirements.',
        image: qatarmedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'thai-visa-medical-certificate',
        name: 'Thai Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Thai visa requirements.', // eslint-disable-line max-len
        image: thaimedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'vietnam-visa-medical-certificate',
        name: 'Vietnam Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Vietnamese visa requirements.',
        image: vietnammedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'taiwan-visa-medical-certificate',
        name: 'Taiwan Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Taiwanese visa requirements.',
        image: taiwanmedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'indonesia-visa-medical-certificate',
        name: 'Indonesia Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Indonesian visa requirements.',
        image: indonesiamedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'south-korea-visa-medical-certificate',
        name: 'South Korea Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for South Korean visa requirements.',
        image: southkoreamedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'malaysia-visa-medical-certificate',
        name: 'Malaysia Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Malaysian visa requirements.', // eslint-disable-line max-len
        image: malasiamedicalcertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'philippines-visa-medical-certificate',
        name: 'Philippines Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Filipino visa requirements.', // eslint-disable-line max-len
        image: philippinescertificate,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: true,
        requiresPhotoEvidence: false,
    },
    {
        id: 'singapore-visa-medical-certificate',
        name: 'Singapore Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Singaporean visa requirements.',
        image: singaporevisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'brunei-visa-medical-certificate',
        name: 'Brunei Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Bruneian visa requirements.',
        image: bruneivisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'cambodia-visa-medical-certificate',
        name: 'Cambodia Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Cambodian visa requirements.',
        image: cambodiavisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'laos-visa-medical-certificate',
        name: 'Laos Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Laotian visa requirements.', // eslint-disable-line max-len
        image: loasvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'myanmar-visa-medical-certificate',
        name: 'Myanmar Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Myanmar visa requirements.',
        image: myanmarvisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },
    {
        id: 'timor-leste-visa-medical-certificate',
        name: 'Timor-Leste Visa Medical Certificate',
        price: 1,
        description: 'A specific medical certificate for Timor-Leste visa requirements.', // eslint-disable-line max-len
        image: timorlestevisa,
        category: 'Visa Medical Certificates',
        path: '/services/visa-medical-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'visa-medical',
        requiresPhotoEvidence: false,
    },

    // // Recovery Certificates
    {
        id: 'covid-19-recovery',
        name: 'COVID-19 Recovery Certificate',
        price: 1,
        description: 'A verifiable medical certificate confirming your recovery from COVID-19.', // eslint-disable-line max-len
        image: unwellwork,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: true,
        requiresPhotoEvidence: false,
    },
    {
        id: 'chickenpox-recovery',
        name: 'Chickenpox (Varicella) Travel Certificate',
        price: 1,
        description: 'A certificate to confirm you or your child is no longer infectious and fit to travel.', // eslint-disable-line max-len
        image: chickenpoxrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: true,
    },
    {
        id: 'shingles-recovery',
        name: 'Shingles Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from shingles.',
        image: shinglesrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: true,
    },
    {
        id: 'scarlet-fever-recovery',
        name: 'Scarlet Fever Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from scarlet fever.',
        image: scarletfeverrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'pneumonia-recovery',
        name: 'Pneumonia Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from pneumonia.', // eslint-disable-line max-len
        image: pneumoniarecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'tonsillitis-recovery',
        name: 'Tonsillitis Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from tonsillitis.', // eslint-disable-line max-len
        image: tonsillitisrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'bronchitis-recovery',
        name: 'Bronchitis Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from bronchitis.', // eslint-disable-line max-len
        image: bronchitisrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'glandular-fever-recovery',
        name: 'Glandular Fever Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from glandular fever.',
        image: glandularfeverrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'measles-recovery',
        name: 'Measles Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from measles.', // eslint-disable-line max-len
        image: measlesrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: true,
    },
    {
        id: 'mumps-recovery',
        name: 'Mumps Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from mumps.', // eslint-disable-line max-len
        image: mumpsrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'rubella-recovery',
        name: 'Rubella Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from rubella.', // eslint-disable-line max-len
        image: rubellarecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresPhotoEvidence: true,
    },
    {
        id: 'whooping-cough-recovery',
        name: 'Whooping Cough Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from whooping cough.', // eslint-disable-line max-len
        image: whoopingcoughrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'hand-foot-mouth-recovery',
        name: 'Hand, Foot & Mouth Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from hand, foot, and mouth disease.', // eslint-disable-line max-len
        image: handfootmouthrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: true,
    },
    {
        id: 'gastroenteritis-recovery',
        name: 'Gastroenteritis Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from gastroenteritis.', // eslint-disable-line max-len
        image: gastroenteritisrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: false,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'cellulitis-recovery',
        name: 'Cellulitis Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from cellulitis.', // eslint-disable-line max-len
        image: cellulitisrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: true,
    },
    {
        id: 'ear-infection-recovery',
        name: 'Ear Infection Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from an ear infection.', // eslint-disable-line max-len
        image: earinfectionrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'sinusitis-recovery',
        name: 'Sinusitis Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from sinusitis.', // eslint-disable-line max-len
        image: sinusitisrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'uti-recovery',
        name: 'Urinary Tract Infection (UTI) Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from a UTI.', // eslint-disable-line max-len
        image: utirecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: true,
    },
    {
        id: 'migraine-recovery',
        name: 'Migraine Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from a migraine episode.', // eslint-disable-line max-len
        image: migrainerecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
    {
        id: 'vertigo-recovery',
        name: 'Vertigo Recovery Certificate',
        price: 1,
        description: 'A medical certificate confirming your recovery from vertigo.', // eslint-disable-line max-len
        image: vertigorecovery,
        category: 'Recovery Certificates',
        requiresQuestionnaire: true,
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresPhotoEvidence: false
    },
    {
        id: 'back-pain-recovery',
        name: 'Back Pain Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from an episode of back pain.', // eslint-disable-line max-len
        image: backpainrecovery,
        requiresQuestionnaire: true,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates'
    },
    {
        id: 'anxiety-stress-recovery',
        name: 'Anxiety & Stress Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from an episode of anxiety or stress.', // eslint-disable-line max-len
        image: anxietystressrecovery,
        requiresQuestionnaire: true,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates'
    },
    {
        id: 'depression-recovery',
        name: 'Depression Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from an episode of depression.', // eslint-disable-line max-len
        image: depressionrecovery,
        requiresQuestionnaire: true,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates'
    },
    {
        id: 'insomnia-recovery',
        name: 'Insomnia Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from an episode of insomnia.', // eslint-disable-line max-len
        image: insomniarecovery,
        requiresQuestionnaire: true,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates'
    },
    {
        id: 'panic-attack-recovery',
        name: 'Panic Attack Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from a panic attack.', // eslint-disable-line max-len
        image: panicattackrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresPhotoEvidence: false,
    },
    {
        id: 'bereavement-recovery',
        name: 'Bereavement Recovery Certificate',
        price: 1, // Price in pence as an integer
        description: 'A medical certificate confirming your recovery from a period of bereavement.', // eslint-disable-line max-len
        image: bereavementrecovery,
        category: 'Recovery Certificates',
        path: '/services/recovery-certificates',
        requiresScr: true,
        requiresId: true,
        requiresVideo: true,
        requiresSupportingDocs: true,
        requiresQuestionnaire: 'clinical-recovery',
        requiresPhotoEvidence: false,
    },
];
/* eslint-enable max-len */
